import { AdvancedMarker, InfoWindow , useMap } from '@vis.gl/react-google-maps';
import SvgIcon from '@mui/material/SvgIcon';
import Supercluster from 'supercluster';
import {useEffect, useRef, useState} from 'react';
import {useTheme} from '@mui/material/styles';
import MapsUgcIcon from '@mui/icons-material/MapsUgc';
import ClusterIcon from "./ClusterIcon";
import DetailIcon from "./DetailIcon";
import ReactDOMServer from "react-dom/server";

const Markers = (props) => {
  const {
    points
  } = props;
  const theme = useTheme();
  const [clusters, setClusters] = useState([]);
  const [hoveredDevice, setHoveredDevice] = useState(null);
  const [infoWindows,setInfoWindows] = useState([])
  const [colorWindow, setColorWindow] = useState(theme.palette.mode === 'dark' ? '#0E131D' : '#f5f5f5');
  const [colorText, setColorText] = useState(theme.palette.mode === 'dark' ? '#fff' : '#000');
  const superclusterRef = useRef(new Supercluster({ radius: 40, maxZoom: 16 }));
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    map.addListener('zoom_changed', () => {
      setTimeout(handleZoomChanged, 450);
    });

    if (theme.palette.mode === 'dark') {
      setColorWindow('#0E131D');
      setColorText('#FFFFFF');
    } else {
      setColorWindow('#f5f5f5');
      setColorText('#000000');
    }

    setTimeout(updateClusters, 300);

  }, [map, theme.palette.mode, points]);

  const colorConfig = {
    100: '#27a027',
    0: '#db524b'
  };
  
  const updateClusters = () => {
    if (!map || !superclusterRef.current || !map.getBounds()) return;
    const bounds = map.getBounds().toJSON();
    const zoom = map.getZoom();

    superclusterRef.current.load(points.map((point, index) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [parseFloat(point.lng), parseFloat(point.lat)]
      },
      properties: {
        ...point,
        color: colorConfig[point.disponibilidad],
        index
      }
    })));

    const clustersTmp = superclusterRef.current.getClusters([
      bounds.west,
      bounds.south,
      bounds.east,
      bounds.north
    ], zoom);

    clustersTmp.forEach(cluster => {
      const childMarkers = cluster.properties.cluster
        ? superclusterRef.current.getLeaves(cluster.id, Infinity)
        : [cluster];
      const statusCounts = childMarkers.reduce((acc, marker) => {
        const disponib = marker.properties.disponibilidad;
        acc[disponib] = (acc[disponib] || 0) + 1; // Incrementar conteo por disponibilidad
        return acc;
      }, {});

// Total de dispositivos en el clúster
      const totalCount = childMarkers.length;

// Inicializar color como verde por defecto
      let color = '#27a027';

      if ((statusCounts['100'] || 0) / totalCount > 0.50) {
        color = '#27a027'; 
      } else {
        color = '#db524b'; 
      }
      cluster.properties.color = color;
    });

    setClusters(clustersTmp);
  };
  
  const handleZoomChanged = (event) => {
    updateClusters();
  };
  
  
  const getColorCluster = () => {
    let colors = [];

    clusters.forEach(cluster => {
      let maxStatus = '';

      if (cluster.properties.cluster) {
        const childMarkers = superclusterRef.current.getLeaves(cluster.id, Infinity);
        const statusCounts = childMarkers.reduce((acc, marker) => {
          const dispon = marker.properties.disponibilidad;
          acc[dispon] = (acc[dispon] || 0) + 1;
          return acc;
        }, {});

        if (statusCounts['100']) {
          maxStatus = 'disponible';
        } else {
          maxStatus = 'indisponible';
        } 

        colors.push(colorConfig[maxStatus]);
      } else {
        colors.push(colorConfig[cluster.properties.disponibilidad]);
      }
    });

    return colors;
  }

 
  const renderToString = (component) => {
    return ReactDOMServer.renderToString(component);
  };
  
  const handleClick = (event, cluster) => {
    setHoveredDevice(null);

    let infowindowTmp = new google.maps.InfoWindow();
    setInfoWindows(prevInfoWindows => [...prevInfoWindows, infowindowTmp]);

    // Obtén los marcadores hijos del clúster
    const childMarkers = cluster.properties.point_count > 0
      ? superclusterRef.current.getLeaves(cluster.id, Infinity)
      : [cluster];

    const statusCounts = childMarkers.reduce((acc, marker) => {
      const status = marker.properties.disponibilidad;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    // Crear contenido del InfoWindow
    let infoWindowContent = `<div style="background-color: ${colorWindow}; color: ${colorText};">`;
    
    // Agregar lista de dispositivos
    infoWindowContent += '<h4>Dispositivos:</h4><ul>';
    childMarkers.forEach(marker => {
      const { nodeId, dsNodo, disponibilidad} = marker.properties; // Obtén nodeid y dsnodo
      infoWindowContent += `<li>${nodeId} - ${dsNodo} - Disponibilidad: ${disponibilidad}</li>`; // Agrega al contenido
    });
    infoWindowContent += '</ul></div>'; // Cierra la lista y el div

    infowindowTmp.setContent(infoWindowContent);
    infowindowTmp.setPosition(event.latLng);
    infowindowTmp.open(map);

    google.maps.event.addListener(infowindowTmp, 'domready', function() {
      changeColorWindow();
    });
  };

  const getStatusFromSVG = (svgElement) => {
    const pathElement = svgElement.querySelector('path');
    const strokeColor = pathElement.getAttribute('stroke');
    const colorToStatus = {
      '100': 'disponible',
      '0': 'indisponible'
    };
    const status = colorToStatus[strokeColor]
    return status
  }
  
  const addClickButton = (childMarkers,infowindow) => {
    const buttons = document.getElementsByClassName('last-clicked-svg');
    if (buttons.length > 0) {
      Array.from(buttons).forEach(button => {
        const parent = button.parentNode
        const iconStatus = parent.querySelector('#icon-status');
        button.addEventListener('click', function(event) {
          event.stopPropagation();
          const statusIcon = getStatusFromSVG(iconStatus);
          showDetailTable(childMarkers, infowindow, statusIcon);
        });
      });
    }
  }

  const showDetailTable = (pointsTmp,infowindow,status) => {
    infowindow.close()
    const filteredPoints = pointsTmp.filter(point => point.properties.disponibilidad === status);
    const pointsTable = filteredPoints.map((obj) => {
      const { group, host_addr, name, disponibilidad } = obj.properties;
      return { group, host_addr, name, disponibilidad };
    });
  }
  
  const changeColorWindow = () =>{
    const infoWindowContainer = document.querySelector('.gm-style-iw.gm-style-iw-c');
    const windowBackground = document.querySelector('.gm-style-iw-d');
    if (infoWindowContainer) {
      infoWindowContainer.style.setProperty('background-color', colorWindow, 'important');
      infoWindowContainer.style.setProperty('padding-right', '15px', 'important');
      infoWindowContainer.style.setProperty('padding-bottom', '15px', 'important');
      windowBackground.style.overflow = 'hidden';
    }
    const closeButtonIcon = document.querySelector('.gm-style-iw button span');
    if (closeButtonIcon) {
      closeButtonIcon.style.filter = 'invert(65%)';
    }
  }
  
  const closeInfoWindows = (markerSimple) => {
    if(infoWindows.length > 1 || (infoWindows.length && markerSimple)){
      infoWindows[0].close();
      setInfoWindows(prevInfoWindows => prevInfoWindows.slice(1));
    }
  }
  
  const handleWindow = (point) => {
    setHoveredDevice(null);
    closeInfoWindows(true);
    setHoveredDevice(point);
    setTimeout(changeColorWindow, 250);
  };
  
  const createKey = (lat, lng, index) => {
    return lat + lng + index;
  };
  
  return (
    <>
      {clusters && clusters.map((cluster, index) => {
        const [lng, lat] = cluster.geometry.coordinates;
        const isCluster = cluster.properties.point_count > 0;
        const clusterSize = isCluster ? cluster.properties.point_count : 1;
        const colors = getColorCluster();

        const color = cluster.properties.color;

        return (
          <AdvancedMarker
            position={{ lat, lng }}
            key={createKey(lat, lng, index)}
            onClick={(event) => isCluster ? handleClick(event, cluster) : handleWindow(cluster.properties)}
            collisionBehavior='REQUIRED'
          >
            <ClusterIcon color={color} total={clusterSize} />

            {/* Renderiza InfoWindow si es un clúster y se ha hecho clic en él */}
            {isCluster && hoveredDevice === cluster.properties && (
              <InfoWindow
                position={{ lat, lng }}
                onCloseClick={() => setHoveredDevice(null)}
                style={{ backgroundColor: colorWindow, color: colorText }}
              >
                <div>
                  <h4>Lista de Dispositivos</h4>
                  <ul>
                    {/* Muestra cada dispositivo en el clúster */}
                    {cluster.properties.childMarkers.map((device, idx) => (
                      <li key={idx}>
                        {device.properties.nodeid} - {device.properties.dsnodo} - Disponibilidad: ${device.disponibilidad}
                      </li>
                    ))}
                  </ul>
                </div>
              </InfoWindow>
            )}

            {/* Renderiza InfoWindow para un marcador individual */}
            {!isCluster && hoveredDevice === cluster.properties && (
              <InfoWindow
                position={{ lat, lng }}
                onCloseClick={() => setHoveredDevice(null)}
                style={{ backgroundColor: colorWindow, color: colorText }}
              >
                <div>
                  {cluster.properties.nodeId} - {cluster.properties.dsNodo} - Disponibilidad: ${cluster.properties.disponibilidad}
                </div>
              </InfoWindow>
            )}
          </AdvancedMarker>
        );
      })}
    </>
  );
};

export default Markers;